import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'

export const PreviousRecipe = styled(ActionButton)`
  margin: 0 auto 6rem auto;
`
export const MoreRecipe = styled(ActionButton)`
  margin: 6rem auto 0 auto;
`
export const RecipeCardListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
`

export const NoResults = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_18}
  margin-bottom: 1.5rem;
  width: 100%;
  text-align: center;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_32}
    margin-bottom: 3.5rem;
    margin-top: 4rem;
  }
`

export const RecipeCardListGrid = styled.div`
  display: grid;
  justify-content: center;
  width: 100%;
  column-gap: 1rem;
  grid-template-columns: repeat(1, 100%);
  row-gap: 2rem;

  @media ${mq(sizes.tablet)} {
    grid-template-columns: repeat(2, 29rem);
    column-gap: 2rem;
  }

  @media ${mq(sizes.desktop)} {
    grid-template-columns: repeat(3, 29rem);
    column-gap: 4rem;
    row-gap: 4rem;
  }
`
